











































































































import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";
import storeHelper from "../../../store/store-helper";
import { Controllers, DocumentContent, DocumentTypePrimitive, PrintCoverPageMode } from "@infoland/iprova-api";
import { DocumentVersionState, PrintDocumentParts, PrintDocumentWizardScreens, PrintHeaderOptions, PrintingAction, PrintTemplateType } from "@/enums";
import Shared from "../../../shared";
import { OptionItem, PrintDocument, PrintStatus, PrintStatusPost, PrintTemplate } from "@/types/printDocument";

const checkPrintStatusTimer: number = 1;
const noCoverPageTemplateId: number = -2;

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "PrintDocument",
    components: {},
    props: {
        documentProperties: Object,
        isReviewDocument: Boolean
    },
    data: function () {
        return {
            selectedTemplateId: null as number,
            documentUrl: null as string,
            templates: [] as PrintTemplate[],
            loadingInProgress: false as boolean,
            closePopup: false as boolean,
            selectedDocumentParts: [] as number[],
            documentParts: [] as OptionItem[],
            displayPrintTemplateSelector: true as boolean,
            printTypes: [
                {
                    id: PrintDocumentParts.WholeDocument,
                    name: "document.printWholeDocument"
                },
                {
                    id: PrintDocumentParts.Selection,
                    name: "document.printSelection"
                }
            ] as OptionItem[],
            printType: PrintDocumentParts.WholeDocument,
            currentScreen: PrintDocumentWizardScreens.Templates,
            printHeaderOptions: [
                {
                    id: PrintHeaderOptions.Yes,
                    name: "general.buttons.yes"
                },
                {
                    id: PrintHeaderOptions.No,
                    name: "general.buttons.no"
                }
            ] as OptionItem[],
            printHeaderSelectionId: PrintHeaderOptions.Yes
        };
    },
    async created() {
        //register handler for dialog OK button
        this.loadingInProgress = true;
        this.registerHandlers({ ok: this.okButtonHandler });
        if (!this.documentProperties.is_printable) {
            this.$emit("hide-ok-button");
            this.currentScreen = PrintDocumentWizardScreens.DownloadableTemplates;
        }

        await this.setPrintTemplates();
        if (!this.isDownloadableTemplatesScreen) {
            if (this.templates.length > 0) {
                this.selectedTemplateId = this.templates[0].print_template_id;
            }
            if (this.supportsPartialPrint) {
                await this.loadDocumentParagraphs();
            }
            this.applyCoverPageSettings();
        }
        this.loadingInProgress = false;
    },
    computed: {
        supportsPartialPrint(): boolean {
            return DocumentTypePrimitive.structured_document == this.documentProperties.type;
        },
        downloadTargetWindow(): string {
            if (/iphone|ipad|ipod/i.test(window.navigator.userAgent)) return "_blank";
            else return "_self";
        },
        supportsPdf(): boolean {
            return !/iphone|ipad|ipod|android/i.test(window.navigator.userAgent);
        },
        printWholeDocument(): boolean {
            return this.printType == PrintDocumentParts.WholeDocument;
        },
        isTemplatesScreen(): boolean {
            return this.currentScreen === PrintDocumentWizardScreens.Templates;
        },
        isDownloadableTemplatesScreen(): boolean {
            return this.currentScreen === PrintDocumentWizardScreens.DownloadableTemplates;
        },
        isDocumentScreen(): boolean {
            return this.currentScreen === PrintDocumentWizardScreens.Document;
        },
        showPrintHeader(): boolean {
            return (
                !this.documentProperties.print_header_required &&
                this.documentProperties.parsed_header != null &&
                this.documentProperties.parsed_header != undefined &&
                this.documentProperties.parsed_header != ""
            );
        }
    },
    methods: {
        async loadDocumentParagraphs() {
            let docContent: DocumentContent = (await storeHelper.documentStore.getDocumentContentByStateAsync(
                this.documentProperties.document_id,
                this.isReviewDocument ? DocumentVersionState.Review : DocumentVersionState.Published
            )) as DocumentContent;
            this.documentParts = docContent.paragraphs.map(p => {
                return {
                    id: p.paragraph_id,
                    name: p.title
                };
            });
        },
        //When return is true the popup closes
        async okButtonHandler(): Promise<boolean> {
            if (this.closePopup) {
                return true;
            }
            if (this.isDownloadableTemplatesScreen) {
                return true;
            }
            if (this.isTemplatesScreen) {
                this.currentScreen = PrintDocumentWizardScreens.Document;
                this.loadingInProgress = true;
                this.$emit("hide-ok-button");
                this.startPrintingProcessAsync();
                this.closePopup = true;
                return false;
            }

            if (this.isDocumentScreen) {
                return false;
            }
            return true;
        },
        async startPrintingProcessAsync() {
            let printInfo: PrintDocument = {
                documentParts: this.selectedDocumentParts.length > 0 ? this.selectedDocumentParts.join("|") : "",
                forcedHeader:
                    this.documentProperties.print_header_required ||
                    (this.documentProperties.parsed_header && this.printHeaderSelectionId == PrintHeaderOptions.Yes)
                        ? true
                        : false,
                outputAsWord: false,
                selectedPrintTemplate: this.selectedTemplateId,
                action: PrintingAction.StartPrinting,
                documentID: this.documentProperties.document_id,
                documentVersion: this.documentProperties.version
            };
            let headers = { "Content-Type": "application/x-www-form-urlencoded", Accept: "text/plain" };
            let pollId = await Controllers.GenericController.postAsync<PrintDocument, string>(
                "../iDocument/Webservices/Utils.ashx",
                printInfo,
                true,
                headers
            );

            this.doPrintPoll(pollId);
        },
        async doPrintPoll(pollId: string): Promise<void> {
            let headers = { "Content-Type": "application/x-www-form-urlencoded", Accept: "text/plain" };
            let printStatusPost: PrintStatusPost = { pollID: pollId, action: PrintingAction.PrintStatus };
            let printStatus: PrintStatus = await Controllers.GenericController.postAsync<PrintStatusPost, PrintStatus>(
                "../iDocument/Webservices/Utils.ashx",
                printStatusPost,
                true,
                headers
            );
            switch (printStatus.status) {
                case "Generating":
                    setTimeout(this.doPrintPoll.bind(this, pollId), checkPrintStatusTimer * 1000);
                    break;
                case "Complete":
                    this.printDocumentCompleted(printStatus, pollId);
                    break;
                case "Failed":
                    await storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString());
                    break;
            }
        },
        async printDocumentCompleted(printStatus: PrintStatus, pollId: string) {
            if (!this.isDownloadableTemplatesScreen) {
                if (!this.supportsPdf) {
                    location.href = printStatus.result + "&DownloadToken=" + pollId;
                    this.$emit("close-dialog");
                    return;
                }
                this.documentUrl = printStatus.result;
                this.$emit("change-dialog-size");
                this.loadingInProgress = false;
            } else {
                let fileName = this.templates.find(t => t.print_template_id == this.selectedTemplateId).name;
                this.downloadFile(printStatus.result, fileName + ".pdf");
            }
        },
        getDocumentLink() {
            if (this.isReviewDocument) {
                return Shared.GetAuthenticatedUrl(
                    `${Shared.iProvaApiUrl}/documents/${this.documentProperties.document_id}/${DocumentVersionState.Review}/download`
                );
            } else {
                return Shared.GetAuthenticatedUrl(`${Shared.iProvaApiUrl}/documents/${this.documentProperties.document_id}/download`);
            }
        },
        onTemplateDownloadClick(templateId) {
            this.selectedTemplateId = templateId;
            this.startPrintingProcessAsync();
        },
        applyCoverPageSettings() {
            let hasNoCoverPageOption = this.templates.some(t => t.print_template_id == noCoverPageTemplateId);
            if (
                hasNoCoverPageOption &&
                this.documentProperties.office_print_cover_page_mode != PrintCoverPageMode.optional_default_unselected &&
                this.templates.length > 1
            ) {
                this.selectedTemplateId = this.templates[1].print_template_id;
            } else if (this.documentProperties.office_print_cover_page_mode == PrintCoverPageMode.not_used) {
                this.selectedTemplateId = noCoverPageTemplateId;
                this.displayPrintTemplateSelector = false;
            } else if (this.documentProperties.office_print_cover_page_mode !== PrintCoverPageMode.not_used) {
                if (this.templates.length == 1 && !hasNoCoverPageOption) {
                    this.displayPrintTemplateSelector = false;
                }
            }

            if (!this.displayPrintTemplateSelector! && !this.showPrintHeader && !this.supportsPartialPrint) {
                //jump to next screen
                this.okButtonHandler();
            }
        },

        downloadDocument() {
            this.downloadFile(
                this.getDocumentLink().toString(),
                `${this.documentProperties.title}.${this.documentProperties.download_binary_extension}`
            );
        },

        downloadFile(url: string, fileName: string) {
            // IE
            if ((window.navigator as any).msSaveBlob) {
                var xmlHttp = new XMLHttpRequest();
                xmlHttp.open("GET", url, true);
                xmlHttp.responseType = "blob";
                xmlHttp.onload = function () {
                    let blob = xmlHttp.response;
                    (window.navigator as any).msSaveBlob(blob, fileName);
                };
                xmlHttp.send(null);
            } else {
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                link.setAttribute("target", this.downloadTargetWindow);
                document.body.appendChild(link);
                link.click();
            }
        },
        async setPrintTemplates(): Promise<void> {
            let printTemplateType = PrintTemplateType.Reader;
            if (this.isReviewDocument) {
                printTemplateType = PrintTemplateType.Reviewer;
            }

            const templatesResult = await Controllers.GenericController.getAsync<PrintTemplate[]>("/documents/print_templates");
            if (templatesResult) {
                this.templates = templatesResult.filter((template: PrintTemplate) => {
                    return this.isPrintTemplateScopeSpecific(template, printTemplateType);
                });

                if (this.templates.length === 0) {
                    this.templates = templatesResult.filter((template: PrintTemplate) => {
                        return this.isPrintTemplateScopeGlobal(template, printTemplateType);
                    });
                }
                if (
                    this.documentProperties.is_printable &&
                    (this.documentProperties.office_print_cover_page_mode == PrintCoverPageMode.optional_default_selected ||
                        this.documentProperties.office_print_cover_page_mode == PrintCoverPageMode.optional_default_unselected)
                ) {
                    const noCoverPageTemplate = {
                        print_template_id: noCoverPageTemplateId,
                        name: this.$t("document.documentPrintNoCoverPage")
                    } as PrintTemplate;
                    this.templates.splice(0, 0, noCoverPageTemplate);
                }
            }
        },
        isPrintTemplateScopeSpecific(template: PrintTemplate, printTemplateType: PrintTemplateType): boolean {
            if (template.types)
                return (
                    template.types.includes(printTemplateType) &&
                    template.document_type &&
                    template.document_type.id === this.documentProperties.document_type.id
                );
            else return false;
        },
        isPrintTemplateScopeGlobal(template: PrintTemplate, printTemplateType: PrintTemplateType): boolean {
            if (template.types) return template.types.includes(printTemplateType) && template.document_type == null;
            else return false;
        }
    }
});
